export default "__VITE_ASSET__Bl__$k10__"